import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthenticationContext } from '../../../../application';
import AuthenticationLoadingState from '../molecules/AuthenticationLoadingState';
import { AUTH_TEXTS } from '../../../utils/texts';

interface AdminRouteProps {
  children: React.ReactNode;
  fallbackPath?: string;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ 
  children, 
  fallbackPath = '/dashboard' 
}) => {
  const { isAuthenticated, isLoading, user } = useAuthenticationContext();

  if (isLoading) {
    return <AuthenticationLoadingState message={AUTH_TEXTS.verifyingAdminAccess} />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  if (!user?.isAdmin()) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;